









import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<FeedContentInfoStatuses>({})
export default class FeedContentInfoStatuses extends Vue {
  // PROPS
  @Prop({ type: Array, default: () => [] })

  // FIELDS
  statuses!: FeedInfoStatus[];
}

export interface FeedInfoStatus {
  name: string;
  cnt: number;
}
